module.exports = __webpack_public_path__ + "static/media/banner_img.bd97494b.png";